export default __webpack_public_path__ + "static/media/Character-02.4178fe7e.png";